<template>
  <v-app-bar app clipped-left flat class="app-top-bar">
    <v-app-bar-nav-icon class="nav-toggle" @click.stop="drawerToggle" />

    <div class="business-wrap">
      <div class="business-name">
        {{ currentBusiness ? currentBusiness.name : "" }}
      </div>
    </div>

    <v-spacer />

    <div
      v-if="showSubscriptionStatus"
      :class="['account-status', accountStatusClass]"
      role="status"
      aria-live="polite"
    >
      <span class="account-status-dot"></span>
      <span class="account-status-copy">
        <span class="account-status-label">Account</span>
        <strong>{{ accountStatusLabel }}</strong>
      </span>
    </div>

    <UserMenu />
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import customerService from "@/modules/Customer/service.js";
import UserMenu from "./Menu";

export default {
  name: "layout-app-bar",

  components: {
    UserMenu,
  },

  data() {
    return {
      Customer: [],
      selectedCustomer: null,
      loading: false,
      customerSearch: null,
    };
  },

  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    ...mapGetters("layout", ["getSubscriptionState"]),
    showSubscriptionStatus() {
      return !!(this.currentBusiness && this.currentBusiness.subscribable);
    },
    accountStatusLabel() {
      const state = this.getSubscriptionState || {};
      if (state.loading || !state.checked) return "Checking";
      if (["active", "trialing"].includes(state.status)) return "Active";
      if (state.status === "past_due") return "Payment due";
      if (state.status === "canceled") return "Canceled";
      if (state.status === "missing") return "No subscription";
      if (["unpaid", "incomplete", "incomplete_expired", "paused"].includes(state.status)) return "Inactive";
      if (state.status === "unavailable") return "Check unavailable";
      return "Inactive";
    },
    accountStatusClass() {
      const status = (this.getSubscriptionState || {}).status;
      if (["active", "trialing"].includes(status)) return "account-status-active";
      if (["past_due", "unavailable"].includes(status)) return "account-status-warning";
      if (!this.getSubscriptionState || this.getSubscriptionState.loading || !this.getSubscriptionState.checked) return "account-status-checking";
      return "account-status-inactive";
    },
  },

  watch: {
    selectedCustomer(val) {
      if (val) {
        this.$router.push({ path: `/customer/${val.id}/profile` });
      }
    },
  },

  created() {
    this.getCustomerList();
  },

  methods: {
    ...mapActions("layout", ["drawerToggle"]),

    getCustomerList() {
      this.loading = true;

      return customerService
        .getAll()
        .then((response) => {
          this.Customer = response.data || [];
          return response;
        })
        .catch((error) => {
          console.error("customer list failed", error);
          this.Customer = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.app-top-bar {
  background: #ffffff !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.nav-toggle {
  margin-right: 10px;
}

.business-wrap {
  min-width: 0;
}

.business-name {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 360px;
}

.account-status{font:inherit;border:1px solid transparent;border-radius:13px;padding:6px 10px;display:flex;align-items:center;gap:7px;margin-right:9px;text-align:left}.account-status-dot{width:8px;height:8px;border-radius:50%;background:currentColor;flex:none}.account-status-copy{display:flex;flex-direction:column;line-height:1.05}.account-status-label{font-size:8px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;opacity:.68}.account-status-copy strong{font-size:11px;margin-top:2px;white-space:nowrap}.account-status-active{color:#15803d;background:#ecfdf3;border-color:#bbf7d0}.account-status-warning{color:#b45309;background:#fffbeb;border-color:#fde68a}.account-status-inactive{color:#be123c;background:#fff1f2;border-color:#fecdd3}.account-status-checking{color:#475569;background:#f8fafc;border-color:#e2e8f0}.account-status-checking .account-status-dot{animation:statusPulse 1.2s infinite}@keyframes statusPulse{50%{opacity:.25}}

@media (max-width: 600px) {
  .business-name {
    font-size: 16px;
    max-width: 180px;
  }

  .nav-toggle {
    margin-right: 4px;
  }
  .account-status{padding:8px;margin-right:5px}.account-status-label{display:none}.account-status-copy strong{font-size:10px}
}
</style>
